import { f as t } from "../internals/function-uncurry-this.js";
import { d as i } from "../internals/define-built-in.js";
var n = Date.prototype,
  r = "Invalid Date",
  e = "toString",
  a = t(n[e]),
  o = t(n.getTime);
String(new Date(NaN)) != r && i(n, e, function () {
  var t = o(this);
  return t == t ? a(this) : r;
});